import { AuthContextProps } from "react-oidc-context";
import { Dispatch } from "redux";
import {
  updateAuthContext,
  updateIsAIRagChatOpen,
} from "@src/reducers/your-reducer";
import { getPermissionsSetService } from "@src/cloud-connect/dependency-injection-container/get-permissions-set-service";

/**
 * The cleanup the logout button in the navigation bar performs.
 * Kept in one place so the token-expiry check runs the exact same flow.
 */
export const performLogout = async (
  auth: AuthContextProps,
  dispatch: Dispatch,
): Promise<void> => {
  dispatch(updateIsAIRagChatOpen(false)); // clear support chat state, this will probably be implemented differently using token and ticket information in the future
  // catch here so a failing removeUser does not skip the cleanup below
  await auth
    .removeUser()
    .catch((error) => console.error("Removing the OIDC user failed", error));
  sessionStorage.clear(); // Clear all session storage
  dispatch(updateAuthContext(null)); // Clear Redux
  getPermissionsSetService().clearPermissions(); // clear permissions
  localStorage.removeItem("userAiChatSession"); // Clear AI chat session storage
  localStorage.removeItem("userSupportChatSession");
};
